import { LEAVE_REQUESTS_PATH as LEAVE_REQUESTS_BASE, PRODUCT_META } from '@gb-ticket/shared-types';

export const LEAVE_ROOT = PRODUCT_META.leave.pathPrefix;
export const LEAVE_REQUEST_PATH = `${LEAVE_ROOT}/beantragen`;
export const LEAVE_REQUESTS_PATH = LEAVE_REQUESTS_BASE;
export const LEAVE_INBOX_PATH = `${LEAVE_ROOT}/eingang`;
export const LEAVE_DELEGATE_PATH = `${LEAVE_ROOT}/vertretung`;
export const LEAVE_CALENDAR_PATH = `${LEAVE_ROOT}/kalender`;
export const LEAVE_COLLEAGUES_PATH = `${LEAVE_ROOT}/kolleginnen`;
export const LEAVE_COLLEAGUES_CALENDAR_PATH = `${LEAVE_COLLEAGUES_PATH}/kalender`;
export const LEAVE_COLLEAGUES_ADMIN_CALENDAR_PATH = `${LEAVE_COLLEAGUES_CALENDAR_PATH}/verwaltung`;
export const LEAVE_ADMIN_PATH = `${LEAVE_ROOT}/verwaltung`;
export const LEAVE_ADMIN_POLICY_PATH = `${LEAVE_ADMIN_PATH}/richtlinie`;
export const LEAVE_ADMIN_HOLIDAYS_PATH = `${LEAVE_ADMIN_PATH}/feiertage`;
export const LEAVE_ADMIN_TYPES_PATH = `${LEAVE_ADMIN_PATH}/arten`;
/** Old path. The route redirects to {@link LEAVE_ADMIN_TYPES_PATH}. */
export const LEAVE_ADMIN_SPECIAL_PATH = `${LEAVE_ADMIN_PATH}/sonderurlaub`;
export const LEAVE_ADMIN_BALANCES_PATH = `${LEAVE_ADMIN_PATH}/salden`;
export const LEAVE_ADMIN_CAPACITY_PATH = `${LEAVE_ADMIN_PATH}/besetzung`;
export const LEAVE_ADMIN_EXPORT_PATH = `${LEAVE_ADMIN_PATH}/export`;

export function leaveRequestDetailPath(requestId: string): string {
  return `${LEAVE_REQUESTS_PATH}/${requestId}`;
}

/** Opens the wizard on the date step with an inclusive range already set. */
export function leaveRequestRangePath(from: string, to: string): string {
  const search = new URLSearchParams({ from, to });
  return `${LEAVE_REQUEST_PATH}?${search.toString()}`;
}
